import { ReactNode, createContext, useContext, useState } from "react";

interface ICadStatusContext {
  isCadLoading: boolean;
  setIsCadLoading: (value: boolean) => void;
}

interface ICadStatusProvider {
  children: ReactNode;
}

export const CadStatusContext = createContext<ICadStatusContext | undefined>(
  undefined,
);

export const CadStatusProvider = ({
  children,
}: ICadStatusProvider): ReactNode => {
  const [isCadLoading, setIsCadLoading] = useState<boolean>(false);

  const handleChange = (value: boolean): void => {
    console.log("cadStatus", value);

    setIsCadLoading(value);
  };

  return (
    <CadStatusContext.Provider
      value={{ isCadLoading, setIsCadLoading: handleChange }}
    >
      {children}
    </CadStatusContext.Provider>
  );
};

export const useCadStatus = (): ICadStatusContext => {
  const context = useContext(CadStatusContext);
  if (context === undefined) {
    throw new Error(
      "'useCadStatus' must be used within a 'CadStatusProvider'.",
    );
  }

  return context;
};
